import { Text, Icon, Stack } from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import SystemClient from '../../../../../system/SystemClient';
import { PlanillaPartidoContext } from '../../../../../system/PlanillaPartido/PlanillaPartidoSystem';
import { Jugador } from '../../../../../system/Jugador/Jugador';
import { PlanillaPartidoOficialMesaNoRegsitrado } from '../../../../../system/PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitrado';
import { useContainerStyle } from '../../../../../common/custom-hooks/useStyles';

export const OficialNRCardForConfeccion = ({
  oficialNR,
  system,
  context,
  deleteOficial,
}: {
  oficialNR: PlanillaPartidoOficialMesaNoRegsitrado;
  system: SystemClient;
  context: PlanillaPartidoContext;
  deleteOficial: (o: PlanillaPartidoOficialMesaNoRegsitrado) => void;
}) => {
  const containerStyle = useContainerStyle();

  return (
    <div className="ms-Grid-col ms-sm12" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
      {oficialNR ? (
        <div className="ms-Grid " style={containerStyle}>
          <div className={'ms-Grid-row mt-1'} style={{ padding: '3px', margin: '0.2rem' }}>
            <Stack horizontal>
              <Stack.Item grow>
                <Text variant="mediumPlus" className="bold" block>
                  {oficialNR.getApellido()}, {oficialNR.getNombre()}
                </Text>
                {oficialNR.getDni() && (
                  <>
                    <Text variant="small" className="secondary-text">
                      DNI:
                    </Text>{' '}
                    <Text variant="small" className="secondary-text">
                      {oficialNR.getDni()}
                    </Text>
                  </>
                )}
              </Stack.Item>
              <Stack.Item>
                <Icon
                  iconName="Cancel"
                  className="remove-item-cross clickable"
                  onClick={() => {
                    deleteOficial(oficialNR);
                  }}
                ></Icon>
              </Stack.Item>
            </Stack>
          </div>
        </div>
      ) : null}
    </div>
  );
};
